import React, { useEffect, useState } from "react";
import { X } from "react-bootstrap-icons"; // Bootstrap icon

import "../../Custom.css"; // custom styles

const timeUnits = [
  { label: "Minutes", value: "minutes" },
  { label: "Hours", value: "hours" },
  { label: "Days", value: "days" },
  { label: "Weeks", value: "weeks" },
  { label: "Months", value: "months" },
];

const WaitTimeDrawer = ({ isOpen, onClose, onSave, initialData }) => {
  const [timeValue, setTimeValue] = useState(initialData?.value || 30);
  const [timeUnit, setTimeUnit] = useState(initialData?.unit || "minutes");

  useEffect(() => {
    if (initialData) {
      setTimeValue(initialData?.value || 1);
      setTimeUnit(initialData?.unit || "minutes");
    }
  }, [initialData]);

  const handleSave = () => {
    if (timeValue < 30 && timeUnit === "minutes") {
      alert("Wait duration must be at least 30 minutes");
      return;
    }
    onSave({
      value: timeValue,
      unit: timeUnit,
    });
    onClose();
  };

  return (
    <>
      {/* Overlay */}
      {isOpen && <div className="drawer-overlay" onClick={onClose} />}

      {/* Drawer */}
      <div className={`drawer ${isOpen ? "open" : ""}`}>
        <div className="drawer-content">
          {/* Header */}
          <div className="drawer-header bg-light d-flex justify-content-between align-items-start p-3">
            <div>
              <h5 className="mb-1">Wait Time Configuration</h5>
              <p className="text-muted small mb-0">
                Set the duration to wait before proceeding
              </p>
            </div>
            <button
              type="button"
              className="btn btn-link text-muted p-0"
              onClick={onClose}
            >
              <X size={24} />
            </button>
          </div>

          {/* Body */}
          <div className="drawer-body p-3 flex-grow-1">
            <div className="mb-3">
              <label className="form-label fw-medium">Wait Duration</label>
              <div className="d-flex gap-2">
                <input
                  type="number"
                  min="1"
                  value={timeValue}
                  onChange={(e) =>
                    setTimeValue(parseInt(e.target.value))
                  }
                  className="form-control w-25"
                />
                <select
                  value={timeUnit}
                  onChange={(e) => setTimeUnit(e.target.value)}
                  className="form-select"
                >
                  {timeUnits.map((unit) => (
                    <option key={unit.value} value={unit.value}>
                      {unit.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          {/* Footer */}
          <div className="drawer-footer bg-light p-3 d-flex justify-content-end gap-2">
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-info text-white"
              onClick={handleSave}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default WaitTimeDrawer;
